import React from "react";
import actingImg from '../../assets/images/resources/about-one-img-1.jpg';

const PhotographyMain = () => {
  return (
    <section className="min-h-screen pb-10 bg-white">

      {/* Main Content */}
      <div className="container max-w-6xl px-4 mx-auto mt-8">
        <div className="flex flex-col items-center gap-8 md:flex-row md:items-start">
          {/* Left: Course Image */}
          <div className="w-full md:w-1/2" data-aos="fade-right">
            <img src="https://sunrisingcinevisionacademy.com/public/assets/images/digital-photography.jpg" alt="Digital Photography" className="w-full h-auto rounded-lg shadow-lg" />
          </div>
          {/* Right: Course Intro */}
          <div className="w-full p-2 md:w-1/2" data-aos="fade-left">
            <h2 className="text-2xl font-bold mb-2 text-[#A14D1F]">Master the Art of Digital Photography with Sunrising Cinevision Academy</h2>
            <p className="mb-4 text-gray-700">
              Sunrising Cinevision Academy offers a comprehensive <strong>photography course</strong> designed for beginners and aspiring professionals. Whether you want to master <strong>DSLR photography</strong>, explore <strong>wildlife photography classes</strong>, or enhance your skills through a <strong>photography editing course</strong>, this program provides hands-on training in <strong>digital photography</strong> techniques, composition, lighting, and post-processing.
            </p>
            <h2 className="text-xl font-bold mb-2 text-[#A14D1F]">Course Overview</h2>
            <ul className="pl-5 mb-2 space-y-1 text-gray-700 list-disc">
              <li><strong>Course Title:</strong> Photography Fundamentals</li>
              <li><strong>Course Duration:</strong> 12 Weeks</li>
              <li><strong>Certification:</strong> Diploma in Photography</li>
              <li><strong>Career Paths:</strong> Professional Photographer, Photojournalist, Wildlife Photographer, Event Photographer, Digital Image Editor</li>
            </ul>
            <h2 className="text-xl font-bold mb-2 mt-5 text-[#A14D1F]">What You Will Learn</h2>
            <ul className="pl-5 mb-2 space-y-1 text-gray-700 list-disc">
              <li>Fundamentals of <strong>digital photography</strong> and camera handling</li>
              <li>Techniques in <strong>wildlife photography classes</strong>, portrait, landscape, and street photography</li>
              <li>Understanding <strong>DSLR photography</strong> and mirrorless cameras</li>
              <li>Mastering <strong>lighting, composition, and storytelling</strong> in photography</li>
              <li>Post-processing skills in <strong>Lightroom and Photoshop</strong></li>
              <li>Building a professional <strong>photography portfolio</strong></li>
            </ul>
          </div>
        </div>

        {/* Course Modules */}
        <div className="grid grid-cols-1 gap-6 mt-10 md:grid-cols-2">
          <div className="p-8 bg-white shadow-md rounded-xl" data-aos="fade-up">
            <h3 className="uppercase tracking-wide text-xl font-bold text-[#A14D1F]">Module 1: Introduction to Photography</h3>
            <ul className="pl-5 space-y-1 text-gray-700 list-disc">
              <li>History and evolution of <strong>digital photography</strong></li>
              <li>Types of photography <strong>(portrait, landscape, street, wildlife)</strong></li>
              <li>Basics of <strong>DSLR photography</strong> and camera settings (aperture, shutter speed, ISO)</li>
            </ul>
          </div>
          <div className="p-8 bg-white shadow-md rounded-xl" data-aos="fade-up">
            <h3 className="uppercase tracking-wide text-xl font-bold text-[#A14D1F]">Module 2: Camera Handling and Techniques</h3>
            <ul className="pl-5 space-y-1 text-gray-700 list-disc">
              <li>Understanding <strong>exposure and metering</strong></li>
              <li>Mastering <strong>aperture, shutter speed, and ISO</strong> for creative control</li>
              <li>Exploring different <strong>camera modes (manual, aperture priority, shutter priority)</strong></li>
            </ul>
          </div>
          <div className="p-8 bg-white shadow-md rounded-xl" data-aos="fade-up">
            <h3 className="uppercase tracking-wide text-xl font-bold text-[#A14D1F]">Module 3: Composition and Visual Storytelling</h3>
            <ul className="pl-5 space-y-1 text-gray-700 list-disc">
              <li>Principles of composition <strong>(rule of thirds, leading lines, symmetry)</strong></li>
              <li>Techniques for <strong>visual storytelling</strong></li>
              <li>Using <strong>light and shadow</strong> effectively</li>
            </ul>
          </div>
          <div className="p-8 bg-white shadow-md rounded-xl" data-aos="fade-up">
            <h3 className="uppercase tracking-wide text-xl font-bold text-[#A14D1F]">Module 4: Working with Light</h3>
            <ul className="pl-5 space-y-1 text-gray-700 list-disc">
              <li>Understanding <strong>natural light</strong> and golden hour photography</li>
              <li>Using <strong>artificial light</strong> (flash, continuous lighting, reflectors)</li>
              <li>Lighting techniques for <strong>portrait and still life photography</strong></li>
            </ul>
          </div>
          <div className="p-8 bg-white shadow-md rounded-xl" data-aos="fade-up">
            <h3 className="uppercase tracking-wide text-xl font-bold text-[#A14D1F]">Module 5: Post-Processing and Editing</h3>
            <ul className="pl-5 space-y-1 text-gray-700 list-disc">
              <li>Introduction to <strong>photography editing course</strong> using Lightroom and Photoshop</li>
              <li>Basic image corrections <strong>(exposure, contrast, colour correction)</strong></li>
              <li>Advanced editing <strong>(layers, masks, retouching techniques)</strong></li>
            </ul>
          </div>
          <div className="p-8 bg-white shadow-md rounded-xl" data-aos="fade-up">
            <h3 className="uppercase tracking-wide text-xl font-bold text-[#A14D1F]">Module 6: Advanced Techniques and Portfolio Development</h3>
            <ul className="pl-5 space-y-1 text-gray-700 list-disc">
              <li>Exploring different <strong>photography genres (street, documentary, fine art)</strong></li>
              <li>Advanced composition techniques</li>
              <li>Creating a <strong>professional photography portfolio</strong></li>
            </ul>
          </div>
          <div className="p-8 bg-white shadow-md rounded-xl" data-aos="fade-up">
            <h3 className="uppercase tracking-wide text-xl font-bold text-[#A14D1F]">Course Assessment</h3>
            <ul className="pl-5 space-y-1 text-gray-700 list-disc">
              <li>Weekly photo assignments based on different themes</li>
              <li>Quizzes and tests on photography theory and techniques</li>
              <li>Final portfolio project</li>
              <li>Active participation and attendance</li>
            </ul>
          </div>
        </div>

        {/* Instructors & More */}
        <div className="p-10 mt-10 bg-white shadow-md rounded-xl">
          <h2 className="text-3xl font-bold text-center mb-10 text-[#A14D1F]">Learn from Industry Experts</h2>
          <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
            <div className="p-8 bg-white shadow-md rounded-xl" data-aos="fade-up">
              <h3 className="uppercase tracking-wide text-xl font-bold text-[#A14D1F]">Faculty:</h3>
              <ul className="pl-5 space-y-1 text-gray-700 list-disc">
                <li>Experienced professional photographers</li>
                <li>Industry mentors specializing in <strong>digital photography</strong> and editing</li>
              </ul>
              <h3 className="uppercase tracking-wide text-sm font-semibold mb-3 mt-5 text-[#A14D1F]">Guest Lectures:</h3>
              <ul className="pl-5 space-y-1 text-gray-700 list-disc">
                <li>Renowned photographers and photojournalists</li>
                <li>Experts in <strong>photography editing courses</strong> and wildlife photography</li>
              </ul>
            </div>
            <div className="p-8 bg-white shadow-md rounded-xl" data-aos="fade-up">
              <h3 className="uppercase tracking-wide text-xl font-bold text-[#A14D1F]">Hands-on Training & Equipment</h3>
              <ul className="pl-5 space-y-1 text-gray-700 list-disc">
                <li>Professional <strong>DSLR and mirrorless cameras</strong></li>
                <li>Access to <strong>editing software (Lightroom, Photoshop)</strong></li>
                <li>Studio lighting and outdoor practical sessions</li>
              </ul>
            </div>
            <div className="p-8 bg-white shadow-md rounded-xl md:col-span-2" data-aos="fade-up">
              <h3 className="uppercase tracking-wide text-xl font-bold text-[#A14D1F]">Certification & Career Opportunities</h3>
              <p>Upon successful completion, students receive a <strong>Diploma in Photography</strong>, opening career opportunities as:</p>
              <ul className="pl-5 space-y-1 text-gray-700 list-disc">
                <li><strong>Professional Photographer</strong> (fashion, portrait, wildlife, documentary)</li>
                <li><strong>Photojournalist</strong> for media houses and publications</li>
                <li><strong>Event Photographer</strong> (weddings, corporate events, concerts)</li>
                <li><strong>Digital Image Editor</strong> for brands and creative agencies</li>
              </ul>
            </div>
          </div>
        </div>

        {/* Call to Action */}
        <div className="p-8 mt-10 text-center bg-white shadow-md rounded-xl" data-aos="fade-up">
          <h3 className="uppercase tracking-wide text-lg font-bold mb-4 text-[#A14D1F]">Enroll Today & Transform Your Passion into a Career</h3>
          <p className="mb-6 text-gray-700">
            Join <strong>Sunrising Cinevision Academy’s</strong> photography course and turn your passion into a professional skill. Whether you're looking for <strong>photography classes</strong> or a <strong>diploma in photography</strong>, this course provides the knowledge, experience, and industry connections to succeed in the world of photography.
          </p>
          <a href="/admission" className="inline-block px-8 py-3 text-lg font-bold text-white bg-gradient-to-r from-[#A14D1F] via-[#A14D1F] to-[#4A2F24] rounded-2xl shadow-lg hover:scale-105 transition-transform">Apply Now</a>
        </div>
      </div>
    </section>
  );
};

export default PhotographyMain;
